export const isNativeApplePayAvailable = (
  win: Window | undefined,
  protocol: string
) => {
  const ApplePaySession = (win as any)?.ApplePaySession;

  return Boolean(
    protocol === "https:" &&
      ApplePaySession &&
      ApplePaySession.supportsVersion?.(3) &&
      ApplePaySession.canMakePayments?.()
  );
};
